import React, { useEffect, useState,useRef} from "react";
import PropTypes from "prop-types";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import {useHistory} from 'react-router-dom'; 
import Typography from "@material-ui/core/Typography";
import { spacing } from "@material-ui/system";
import { Box } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import RadioGroup from "@material-ui/core/RadioGroup";
import Radio from "@material-ui/core/Radio";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Slider from "@material-ui/core/Slider";
import Button from "@material-ui/core/Button";
import InputLabel from "@material-ui/core/InputLabel";
import { DropzoneArea } from "material-ui-dropzone";
import Divider from '@material-ui/core/Divider';
import Geographical from "../../../constants/Geographical.json";
import { useStyles } from "../../../styles/styles";
import CustomImage from '../../ImagesComponent';
import ErrorComponent from '../../ErrorComponent';
import { LoadCompanyAction, CompanyStoreAction } from '../../../redux/actions/CustomerAction';
import { useDispatch, useSelector } from 'react-redux';
import { NepaliDatePicker } from "nepali-datepicker-reactjs"
import "nepali-datepicker-reactjs/dist/index.css"
import NepaliDate from 'nepali-date-converter'
const styles = {
  root: {
    backgroundColor: 'transparent !important',
    boxShadow: 'none',
    paddingTop: '25px',
    color: '#FFFFFF'
  },
  customButton: {
    marginTop: "15px",
    marginBottom: "30px",
    backgroundColor: "#67a8e4",
    textTransform: "Capitalize",
    clear: "both",
    paddingTop: "10px",
    paddingBottom: "10px",
    paddingLeft: "30px",
    paddingRight: "30px",

    "&:hover": {
      background: "#67a8e4",
    },
  },
  switchRoot: {
    width: "50px!important",
    height: "24px!important",
    padding: "0px!important",
  },
  switchBase: {
    color: "#818181!important",
    padding: "1px!important",
    "&$checked": {
      "& + $track": {
        backgroundColor: "#23bf58!important",
      },
    },
  },
  thumb: {
    color: "white!important",
    width: "20px!important",
    height: "20px!important",
    margin: "1px!important",
  },
  track: {
    borderRadius: "20px!important",
    backgroundColor: "#818181!important",
    opacity: "1 !important!important",
    "&:after, &:before": {
      color: "white!important",
      fontSize: "11px!important",
      position: "absolute!important",
      top: "6px!important",
    },
    "&:after": {
      content: "'Yes'",
      left: "8px!important",
    },
    "&:before": {
      content: "'No'",
      right: "7px!important",
    },
  },
  checked: {
    color: "#23bf58 !important",
    transform: "translateX(26px) !important",
  },
  verticalGap: {
    '@media (max-width: 500px)': {
      marginTop: "20px"
    },
  },
  notifyUser: {

  },
  datePickerClass:{
    marginTop:"20px"
  },
  inputAdjustment:{
    marginTop:"10px",
    '@media (max-width: 768px)': {
      width: "100%!important",
    },
  },
   fullWidthMobile:{
    '@media (max-width: 768px)': {
      width: "100%!important",
    },
  },
}; 

const defaultValues1 = {
          name_of_company:"",
          company_registration_date:"",
          company_registration_number:"",
          company_province:'',
          company_district:'',
          company_city:'',
          company_ward:'',
          company_place:'',
          company_registration_docs: [],
          company_pan_number:'',
          company_email:'',
          company_contact_number:'',
          company_pan_docs:[],
          company_tax_clearance_docs:[],
          memorandum_of_association:[],
          article_of_association:[],
    
  };
const defaultDropZone =
{
company_registration_docs: [],
company_pan_docs: [],
company_tax_clearance_docs: [],
memorandum_of_association: [],
article_of_association: [],
};
 
function CompanyComponent({ readableStatus, setCompanyRefresh,...props}){
  
    const history = useHistory();  

    //const classes = useStyles();
    const { classes } = props;
    const [geo, setGeo] = useState([]);
    const [loading, setLoading] = useState(false);
    const [formValuesCompany, setFormValuesCompany] = useState(defaultValues1);
    const [deletedFiles, setDeletedFiles] = useState([]);
  const [dropZoneValue, setDropZoneValue] = useState(defaultDropZone);
    const [flagger, setFlagger] = useState(true);
  const [editFlag, setEditFlag] = useState(false);
    const [originalCompanyData, setOriginalCompanyData] = useState({ defaultValues1 });
  const [companyRegistrationDocsFilesInfo, setCompanyRegistrationDocsFilesInfo] = useState([]);
  const [companyPANDocsFilesInfo, setCompanyPANDocsFilesInfo] = useState([]);
  const [companyTaxClearanceDocsFilesInfo, setCompanyTaxClearanceDocsFilesInfo] = useState([]);
  const [MOAFilesInfo, setMOAFilesInfo] = useState([]);
  const [AOAFilesInfo, setAOAFilesInfo] = useState([]);
  const [editLabel, setEditLabel] = useState(false);
  const [renderPage, setRenderPage] = useState(false);
  const [disableEdit,setDisableEdit] = useState(true);
  
  const dispatch = useDispatch();
  const company = useSelector(state => state.customerDetails.company);
  const [companyResponse,setCompanyResponse]=useState('');
  const [CRD, setCRD] = useState("");
  const handleInputChange_ = (value, name) => {
    //nepali to english date converter
    let nepaliDate = new NepaliDate(value)
    var englishDateObj = nepaliDate.getAD();
    var year = englishDateObj.year;
    var tempMonth = englishDateObj.month + 1;
    var month = parseInt(englishDateObj.month) > 9 ? tempMonth : "0" + tempMonth;
    var date = parseInt(englishDateObj.date) > 9 ? englishDateObj.date : "0" + englishDateObj.date;
    setFormValuesCompany({
      ...formValuesCompany,
      company_registration_date: year + "-" + month + "-" + date
    });
   
  

  }
      const handleInputChange = (e) => {

       
    
        const { name, value } = e.target;
        if(name==="company_province"){
            {
              
              geo.length && geo.map((option) => (
    
                  (option.id==value)?
                    option.districts.map(  (district,index) =>(
                        (index==0)? 
                            setFormValuesCompany({
                            ...formValuesCompany,
                            [name]: value,
                            ['company_district']:district.id,
                            ['company_city']:district.municipalities.filter(( municipality,index)=>( index===0?true:false))[0].id,
                            ['company_ward']:1
                            }): true
    
                        ))
                    :true
    
    
              )) 
          }
    
        }else if(name==="company_district"){
          { geo.length && geo.map((option)=>(
             option.districts.map((option)=>(
              (option.id===value)?
                option.municipalities.map((municipality,index)=>(
                  (index==0)?
                  setFormValuesCompany({
                    ...formValuesCompany,
                    [name]: value,
                    ['company_city']:municipality.id,
                    ['company_ward']:1
                    }): true
                )):true
             ))
          ))
    
          }
        }else if(name==="company_city"){
          setFormValuesCompany({
            ...formValuesCompany,
            [name]:value,
            ['company_ward']:1
            })
        }else if(name =="company_registration_date"){
          let nepaliDate = new NepaliDate(new Date(value))
          nepaliDate = nepaliDate.format('YYYY-MM-DD')

          setCRD(nepaliDate);
          setFormValuesCompany({
            ...formValuesCompany,
            [name]: value,
          });
        }
        else{
            setFormValuesCompany({
            ...formValuesCompany,
            [name]: value,
            });
        }
    
    
    
      };
      const handleInputChangeDropzoneRegister = (e) => {
        
        setDropZoneValue({
          ...dropZoneValue,
          ["company_registration_docs"]: e,
        });
      };
      
      const handleInputChangeDropzonePAN = (e) => {
        
        setDropZoneValue({
          ...dropZoneValue,
        ["company_pan_docs"]: e,
        });
      };
      const handleInputChangeDropzoneTax = (e) => {
        
        setDropZoneValue({
          ...dropZoneValue,
          ["company_tax_clearance_docs"]: e,
        });
      };
      const handleInputChangeDropzoneMOA = (e) => {

        setDropZoneValue({
          ...dropZoneValue,
          ["memorandum_of_association"]: e,
        });
      };
      const handleInputChangeDropzoneAOA = (e) => {

        setDropZoneValue({
          ...dropZoneValue,
          ["article_of_association"]: e,
        });
      };
  const enableEdit = (event) => {
    setEditFlag(!editFlag);
  }
  const cancelEdit = (event) => {
    setEditFlag(!editFlag);
    setFormValuesCompany(originalCompanyData);
    setDeletedFiles([]);
    setDropZoneValue(defaultDropZone)
  }

    const fhandleSubmitCompany = (event) => {
        event.preventDefault();
       
      const uploadData = new FormData();
      // Update the formData object
      for (var k in dropZoneValue) {
        if (dropZoneValue.hasOwnProperty(k)) {
          Array.from(dropZoneValue[k]).forEach((image_file) => {

            uploadData.append(k + '[]', image_file)
          })
        }
      }
      deletedFiles.forEach((file) => {
        uploadData.append('deletedFiles[]', parseInt(file));
      });
      
      uploadData.append('name_of_company', formValuesCompany.name_of_company)
      uploadData.append('company_registration_date', formValuesCompany.company_registration_date)
      uploadData.append('company_registration_number', formValuesCompany.company_registration_number)
      uploadData.append('company_province', formValuesCompany.company_province)
      uploadData.append('company_district', formValuesCompany.company_district)
      uploadData.append('company_city', formValuesCompany.company_city)
      uploadData.append('company_ward', formValuesCompany.company_ward)
      uploadData.append('company_place', formValuesCompany.company_place)
      uploadData.append('company_pan_number', formValuesCompany.company_pan_number)
      uploadData.append('company_email', formValuesCompany.company_email)
      uploadData.append('company_contact_number', formValuesCompany.company_contact_number)
      dispatch(CompanyStoreAction(uploadData, setFlagger, flagger, editFlag, setEditFlag, setCompanyResponse, setRenderPage));

      setDeletedFiles([]);
      setDropZoneValue({
        company_registration_docs: [],
        company_pan_docs: [],
        company_tax_clearance_docs: [],
        memorandum_of_association: [],
        article_of_association: [],
      })
      setCompanyResponse(company);
      setCompanyRefresh(true);
      };

    useEffect(() => {
      let abortController;
      abortController = new AbortController();
      let signal = abortController.signal;         
      setLoading(true);
      setCompanyResponse(company);
      setGeo(Geographical)
      let customer_id = parseInt(history.location.pathname.replace('/customer-details/', ''));

      customer_id = isNaN(customer_id) ? 0 : customer_id;
      setFlagger(false);
      
      LoadCompanyAction(customer_id, setCompanyResponse,signal).then(res => {
        if (res.company_flag) {
          setDisableEdit(false);
        }
        if (res.status_code===200){
          setEditLabel(true);
          let value;
          if(res.data.company_registration_date==null){
            var tzoffset = (new Date()).getTimezoneOffset() * 60000; //offset in milliseconds
            value = (new Date(Date.now() - tzoffset)).toISOString().split('T')[0];
          }else{
            value = res.data.company_registration_date;
            let nepaliDate = new NepaliDate(new Date(value))
            nepaliDate = nepaliDate.format('YYYY-MM-DD')
            
            setCRD(nepaliDate);
          }
          
          setFormValuesCompany({
          ...formValuesCompany,
            'name_of_company':res.data.name_of_company,
            'company_registration_date': value,
            'company_registration_number':res.data.company_registration_number,
            'company_province': res.data.company_province !== null ? parseInt(res.data.company_province) : 1,
            'company_district': res.data.company_district !== null ? parseInt(res.data.company_district) : 1, 
            'company_city': res.data.company_city ? parseInt(res.data.company_city) : 1,
            'company_ward': res.data.company_ward ? parseInt(res.data.company_ward) : 1,
            'company_place': res.data.company_place ?? "",
            'company_registration_docs': res.data.company_registration_docs != null ? res.data.company_registration_docs : [],
            'company_pan_number': res.data.company_pan_number,
            'company_email': res.data.company_email,
            'company_contact_number': res.data.company_contact_number,
            'company_pan_docs': res.data.company_pan_docs !=null ? res.data.company_pan_docs : [],
            'company_tax_clearance_docs': res.data.company_tax_clearance_docs !=null ? res.data.company_tax_clearance_docs : [],
            'memorandum_of_association': res.data.memorandum_of_association !=null ? res.data.memorandum_of_association : [],
            'article_of_association': res.data.article_of_association != null ? res.data.article_of_association : [],
            'role_users_id': res.role_users_id != null ? res.role_users_id:3
          });
          setOriginalCompanyData({
            'name_of_company': res.data.name_of_company,
            'company_registration_date': value,
            'company_registration_number': res.data.company_registration_number,
            'company_province': res.data.company_province !== null ? parseInt(res.data.company_province) : 1,
            'company_district': res.data.company_district !== null ? parseInt(res.data.company_district) : 1,
            'company_city': res.data.company_city ? parseInt(res.data.company_city) : 1,
            'company_ward': res.data.company_ward ? parseInt(res.data.company_ward) : 1,
            'company_place': res.data.company_place ?? "",
            'company_registration_docs': res.data.company_registration_docs != null ? res.data.company_registration_docs:[],
            'company_pan_number': res.data.company_pan_number,
            'company_email': res.data.company_email,
            'company_contact_number': res.data.company_contact_number,
            'company_pan_docs': res.data.company_pan_docs != null ? res.data.company_pan_docs:[],
            'company_tax_clearance_docs': res.data.company_tax_clearance_docs != null ? res.data.company_tax_clearance_docs:[],
            'memorandum_of_association': res.data.memorandum_of_association != null ? res.data.memorandum_of_association:[],
            'article_of_association': res.data.article_of_association != null ? res.data.article_of_association:[],
            'role_users_id': res.role_users_id != null ? res.role_users_id : 3
           })
         
          setCompanyRegistrationDocsFilesInfo(res.data.company_registration_docs != null?res.data.company_registration_docs_files_info:[]);
          setCompanyPANDocsFilesInfo(res.data.company_pan_docs != null ?res.data.company_pan_docs_files_info:[]);
          setCompanyTaxClearanceDocsFilesInfo(res.data.company_tax_clearance_docs != null?res.data.company_tax_clearance_docs_files_info:[]);
          setMOAFilesInfo(res.data.memorandum_of_association != null ?res.data.memorandum_of_association_files_info:[]);
          setAOAFilesInfo(res.data.article_of_association != null ?res.data.article_of_association_files_info:[]);
        }
        
      }).finally(() => {
        setLoading(false);

      });
      setRenderPage(false)
        return () => {
          setGeo({}); // This worked for me
          abortController.abort();
        };
    }, [renderPage]);
   
    return (
       <>   {loading && <span>Loading .....</span>}
        {!loading &&
        <>
        <form onSubmit={fhandleSubmitCompany} style={{ textAlign: "left" }} >
                  <Grid container item xs={12}>
            {companyResponse !== '' && companyResponse.success === false &&
              <ErrorComponent error={companyResponse.message} />
            }
              {companyResponse !== '' && companyResponse.success === true && companyResponse.review === true && 
                <ErrorComponent error={companyResponse.message} />
              }
                    <Grid item xs={12}>
             
                {!disableEdit &&
                      <Typography variant="h6" component="div" gutterBottom style={{color:"#0d0d0d",position:"relative"}}>
                  Company Details {!editFlag ? <span style={{ position: "absolute", top: "-15px", right: "0px" }}><Button className={classes.customButton}
                    variant="contained" color="primary" type="button" onClick={(event) => {
                      enableEdit(event);
                    }} style={{ marginTop: "15px", marginBottom: "15px" }} >
                    Enable
                  </Button></span> : <span style={{ position: "absolute", top: "-15px", right: "0px" }}> <Button
                    className={classes.customButton} variant="contained" color="primary" type="button" onClick={(event) => {
                      cancelEdit(event);
                    }} style={{ marginTop: "15px", marginBottom: "15px" }}>
                    Cancel
                  </Button> </span>}
                      </Typography>
                }
                    </Grid>
               <Grid item xs={12} sm={3}>
                    <FormControl variant="outlined" className={[classes.formControl, classes.fullWidthMobile]}>
                      
                      <TextField
                        id="name-input"
                        name="name_of_company"
                        type="text"
                        margin="normal"
                        variant="outlined"
                        label="Name of Company"
                        value={formValuesCompany.name_of_company}
                        onChange={handleInputChange}
                        inputlabelprops={{
                          shrink: true,
                        }}
                       disabled={editFlag ? false : true}
                      />
                      </FormControl>
                    </Grid>
              <Grid item xs={12} sm={3} >
        <FormControl variant="outlined" className={[classes.formControl, classes.fullWidthMobile]}>
                      
                      <TextField
                        id="name-input"
                        name="company_registration_number"
                        type="text"
                        margin="normal"
                        variant="outlined"
                        label="Reg. No."
                        value={formValuesCompany.company_registration_number}
                        onChange={handleInputChange}
                        inputlabelprops={{
                          shrink: true,
                        }}
                       disabled={editFlag ? false : true}
                      />
                      </FormControl>
                    </Grid>
              <Grid item xs={12} sm={3} >
                     <FormControl variant="outlined" className={[classes.formControl, classes.fullWidthMobile]}>
                      
                      <TextField
                        id="name-input"
                        name="company_registration_date"
                        type="date"
                        margin="normal"
                        variant="outlined"
                        label="Reg. Date in AD"
                        value={formValuesCompany.company_registration_date}
                        onChange={handleInputChange}
                        inputlabelprops={{
                          shrink: true,
                        }}
                       disabled={editFlag ? false : true}
                      />
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={3} >
                      <FormControl variant="outlined" className={[classes.formControl, classes.datePickerClass].join("")} >
                        <InputLabel shrink>Reg. Date in BS</InputLabel>
                        <NepaliDatePicker inputClassName="MuiInputBase-input MuiOutlinedInput-input"
                          className="MuiInputBase-root MuiOutlinedInput-root MuiInputBase-formControl"
                          value={CRD}
                          name="company_registration_date"
                          required
                          onChange={(event) => handleInputChange_(event, "company_registration_date")}
                          options={{ calenderLocale: "ne", valueLocale: "en" }} 
                          disabled={editFlag ? false : true}
                          />
                          

                      </FormControl>


                    </Grid>
              <Grid item xs={12} sm={3} >
              <FormControl variant="outlined" className={[classes.formControl, classes.fullWidthMobile]}>

                <TextField
                  id="company_email"
                  name="company_email"
                  type="email"
                  margin="normal"
                  variant="outlined"
                  label="Company Email"
                  value={formValuesCompany.company_email}
                  onChange={handleInputChange}
                  inputlabelprops={{
                    shrink: true,
                  }}
                  disabled={editFlag ? false : true}
                />
              </FormControl>
            </Grid>
              <Grid item xs={12} sm={3} >
              <FormControl variant="outlined" className={[classes.formControl, classes.fullWidthMobile]}>

                <TextField
                  id="company_contact_number"
                  name="company_contact_number"
                  type="text"
                  margin="normal"
                  variant="outlined"
                  label="Contact Number"
                  value={formValuesCompany.company_contact_number}
                  onChange={handleInputChange}
                  inputlabelprops={{
                    shrink: true,
                  }}
                  disabled={editFlag ? false : true}
                />
              </FormControl>
            </Grid>
              <Grid item xs={12} sm={3}  >
              <FormControl variant="outlined" className={[classes.formControl, classes.fullWidthMobile]}>

                <TextField
                  id="company_pan_number"
                  name="company_pan_number"
                  type="text"
                  margin="normal"
                  variant="outlined"
                  label="Company PAN Number"
                  value={formValuesCompany.company_pan_number}
                  onChange={handleInputChange}
                  inputlabelprops={{
                    shrink: true,
                  }}
                  disabled={editFlag ? false : true}
                />
              </FormControl>
            </Grid>
                    <Divider />
                    <Grid item xs={12}>
                      <Typography variant="h6" component="div" gutterBottom style={{  marginTop:"0px",marginBottom:"30px"}}>
                        Company Current Address 
                      </Typography>
                    </Grid>
              <Grid item xs={12} sm={3} >
                    <FormControl variant="outlined" className={[classes.formControl,classes.inputAdjustment]} >
                      <InputLabel>Select Province</InputLabel>
                        <Select
                          name="company_province"
                          label="Select Province"
                          value={formValuesCompany.company_province}
                          onChange={handleInputChange}
                          disabled={editFlag ? false : true}
                        >
                            
                        {geo.map((option) => (
                                <MenuItem key={option.id} value={option.id}>
                                    {option.name}
                                </MenuItem>
                        ))}
                        </Select>
                      </FormControl>
                    </Grid>
              <Grid item xs={12} sm={3}>
                      
                <FormControl variant="outlined" className={[classes.formControl, classes.inputAdjustment]}>
                      <InputLabel>Select District</InputLabel>
                        <Select
                          name="company_district"
                          label="Select District"
                          value={formValuesCompany.company_district}
                          onChange={handleInputChange} 
                          disabled={editFlag ? false : true}
                        >
                            
                        {geo.length && geo.map((option) => (
                          
                           (option.id===formValuesCompany.company_province)?
                           option.districts.map((option) =>(
                             <MenuItem key={option.id} value={option.id}>
                            {option.name}
                            
                          </MenuItem>
                         ))
                            :true
                          
                      
                        )) }
                        </Select>
                      </FormControl>
                    </Grid>
              <Grid item xs={12} sm={3}>
                      
                <FormControl variant="outlined" className={[classes.formControl, classes.inputAdjustment]} >
                      <InputLabel>Select City</InputLabel>
                        <Select
                          name="company_city"
                          label="Select City"
                          value={formValuesCompany.company_city}
                          onChange={handleInputChange} 
                          disabled={editFlag ? false : true}
                        >
                            
                        {geo.length && geo.map((option) => (
                          
                                option.districts.map((option)=>(
                                  
                                   (option.id===formValuesCompany.company_district)?
                                   option.municipalities.map((option) =>(
                                    <MenuItem key={option.id} value={option.id}>
                                   {option.name}
                                   
                                 </MenuItem>
                                ))
                                 
                                   :true
                                ))
                        )) }
                        </Select>
                      </FormControl>
                    </Grid>
              <Grid item xs={12} sm={3}>
                      
                <FormControl variant="outlined" className={[classes.formControl, classes.inputAdjustment]}>
                      <InputLabel>Select Ward</InputLabel>
                        <Select
                          name="company_ward"
                          label="Select Ward"
                          value={formValuesCompany.company_ward}
                          onChange={handleInputChange} 
                          disabled={editFlag ? false : true}
                        >
                           
                        {geo.length && geo.map((option) => (
                          
                                option.districts.map((option)=>(
                                  
                                    option.municipalities.map((option)=>(
                                      (option.id==formValuesCompany.company_city)?
                                       option.wards.map((ward)=>(
                                        <MenuItem key={ward} value={ward}>
                                        Ward {ward}
                                        
                                      </MenuItem>
                                       )):true
                                    ))
                                ))
                        )) }
                        </Select>
                      </FormControl>
                    </Grid>
              <Grid item xs={12} sm={3}>
                <FormControl variant="outlined" className={[classes.formControl, classes.inputAdjustment]}>
                      
                      <TextField
                        id="name-input"
                        name="company_place"
                        type="text"
                        margin="normal"
                        variant="outlined"
                        label="Select Place"
                       
                        value={formValuesCompany.company_place}
                        onChange={handleInputChange}
                        inputlabelprops={{
                          shrink: true,
                        }}
                        disabled={editFlag ? false : true}
                      />
                      </FormControl>
                    </Grid>
                    
                    <Divider />
           
                    <Grid
                      item
                      xs={12}
                      style={{
                        marginTop: "15px",
                        padding: "25px",
                        border: "1px solid #ddd",
                      }}
                    >
                      <Typography
                        variant="subtitle1"
                        component="div"
                        gutterBottom
                        style={{ fontWeight: "bold" }}
                      >
                        Company Registration Document
                      </Typography>
                      <Typography
                        variant="caption"
                        display="block"
                        style={{ marginBottom: "10px" }}
                        gutterBottom
                      >
                        Note* Upload scan copy of Company Regisration document in pdf or jpeg format.
                      </Typography>
              <Grid
                item
                xs={12} container
                style={{
                  marginTop: "15px",
                  marginBottom: "15px",
                  padding: "25px",
                  border: "1px solid #ddd",
                }}
              > 
              {formValuesCompany.company_registration_docs!=undefined && formValuesCompany.company_registration_docs.length!= 0  &&
                formValuesCompany.company_registration_docs.map((option, index) => (
                
                  (deletedFiles.length && deletedFiles.includes(option)) ?
                    false
                    :
                 
                    companyRegistrationDocsFilesInfo.length &&
                    <CustomImage option={option} index={index} deletedFiles={deletedFiles}
                      setDeletedFiles={setDeletedFiles} key={index} editFlag={editFlag} filesInfo={companyRegistrationDocsFilesInfo} /> 

                ))
              }
                </Grid>{editFlag && 
                      <DropzoneArea
                        acceptedFiles={[
                          "image/*",
                          "application/pdf"
                          
                        ]}
                        name="company_registration_docs"
                        filesLimit={3}
                        dropzoneText="Drop files here or click to upload."
                        onChange={handleInputChangeDropzoneRegister}
                        showPreviews={true}
                        showPreviewsInDropzone={false}
                        useChipsForPreview
                        previewGridProps={{ container: { spacing: 1, direction: 'row' } }}
                        previewChipProps={{ classes: { root: classes.previewChip } }}
                        previewText="Selected files"
                        maxFileSize={2048000000000}
                        dropzoneParagraphClass={classes.dropzoneParagraphClass}
                        disabled={editFlag ? false : true}
                      />

                }
                    </Grid>
                    <Divider />
                    <Grid
                      item
                      xs={12}
                      style={{
                        marginTop: "15px",
                        padding: "25px",
                        border: "1px solid #ddd",
                      }}
                    >
                      <Typography
                        variant="subtitle1"
                        component="div"
                        gutterBottom
                        style={{ fontWeight: "bold" }}
                      >
                        Company PAN Document
                      </Typography>
                      <Typography
                        variant="caption"
                        display="block"
                        style={{ marginBottom: "10px" }}
                        gutterBottom
                      >
                        Note* Upload scan copy of Company PAN document in pdf or jpeg format.
                      </Typography>
              <Grid
                item
                xs={12} container
                style={{
                  marginTop: "15px",
                  marginBottom: "15px",
                  padding: "25px",
                  border: "1px solid #ddd",
                }}
              > 
              {formValuesCompany.company_pan_docs != undefined && formValuesCompany.company_pan_docs.length != 0 &&
                formValuesCompany.company_pan_docs.map((option, index) => (

                  (deletedFiles.length && deletedFiles.includes(option)) ?
                    false
                    : companyPANDocsFilesInfo.length && 
                    <CustomImage option={option} index={index} deletedFiles={deletedFiles}
                      setDeletedFiles={setDeletedFiles} key={index} editFlag={editFlag} filesInfo={companyPANDocsFilesInfo} />

                ))
              }</Grid>
                {editFlag && 
                      <DropzoneArea
                        acceptedFiles={[
                          "image/*",
                          "application/pdf"
                          
                        ]}
                        name="company_pan_docs"
                        filesLimit={3}
                        dropzoneText="Drop files here or click to upload."
                        onChange={handleInputChangeDropzonePAN}
                        showPreviews={true}
                        showPreviewsInDropzone={false}
                        useChipsForPreview
                        previewGridProps={{ container: { spacing: 1, direction: 'row' } }}
                        previewChipProps={{ classes: { root: classes.previewChip } }}
                        previewText="Selected files"
                        maxFileSize={20480000000}
                        dropzoneParagraphClass={classes.dropzoneParagraphClass}
                        disabled={editFlag ? false : true}
                      />
}
                    </Grid>
                    <Divider />
                    <Grid
                      item
                      xs={12}
                      style={{
                        marginTop: "15px",
                        padding: "25px",
                        border: "1px solid #ddd",
                      }}
                    >
                      <Typography
                        variant="subtitle1"
                        component="div"
                        gutterBottom
                        style={{ fontWeight: "bold" }}
                      >
                        Company Tax Clearance Document
                      </Typography>
                      <Typography
                        variant="caption"
                        display="block"
                        style={{ marginBottom: "10px" }}
                        gutterBottom
                      >
                        Note* Upload scan copy of Company Tax Clearance document in pdf or jpeg format.
                      </Typography>
              <Grid
                item
                xs={12} container
                style={{
                  marginTop: "15px",
                  marginBottom: "15px",
                  padding: "25px",
                  border: "1px solid #ddd",
                }}
              > 
             
              {formValuesCompany.company_tax_clearance_docs != undefined && formValuesCompany.company_tax_clearance_docs.length != 0 &&
                formValuesCompany.company_tax_clearance_docs.map((option, index) => (

                  (deletedFiles.length && deletedFiles.includes(option)) ?
                    false
                    : companyTaxClearanceDocsFilesInfo.length &&
                    <CustomImage option={option} index={index} deletedFiles={deletedFiles}
                      setDeletedFiles={setDeletedFiles} key={index} editFlag={editFlag} filesInfo={companyTaxClearanceDocsFilesInfo} />

                ))
              }
                </Grid>{editFlag && 
                      <DropzoneArea
                        acceptedFiles={[
                          "image/*",
                          "application/pdf"
                          
                        ]}
                        name="company_tax_clearance_docs"
                        filesLimit={3}
                        dropzoneText="Drop files here or click to upload."
                        onChange={handleInputChangeDropzoneTax}
                  showPreviews={true}
                  showPreviewsInDropzone={false}
                  useChipsForPreview
                  previewGridProps={{ container: { spacing: 1, direction: 'row' } }}
                  previewChipProps={{ classes: { root: classes.previewChip } }}
                  previewText="Selected files"
                        maxFileSize={20480000000}
                        dropzoneParagraphClass={classes.dropzoneParagraphClass}
                        disabled={editFlag ? false : true}
                      />

                }
                    </Grid>
            <Divider />
            <Grid
              item
              xs={12}
              style={{
                marginTop: "15px",
                padding: "25px",
                border: "1px solid #ddd",
              }}
            >
              <Typography
                variant="subtitle1"
                component="div"
                gutterBottom
                style={{ fontWeight: "bold" }}
              >
                Memorandum of Association(MOA) Document
              </Typography>
              <Typography
                variant="caption"
                display="block"
                style={{ marginBottom: "10px" }}
                gutterBottom
              >
                Note* Upload scan copy of Memorandum of Association(MOA) document in pdf format.
              </Typography>
              <Grid
                item
                xs={12} container
                style={{
                  marginTop: "15px",
                  marginBottom: "15px",
                  padding: "25px",
                  border: "1px solid #ddd",
                }}
              > 
              {formValuesCompany.memorandum_of_association != undefined && formValuesCompany.memorandum_of_association.length != 0 &&
                formValuesCompany.memorandum_of_association.map((option, index) => (

                  (deletedFiles.length && deletedFiles.includes(option)) ?
                    false
                    : MOAFilesInfo.length &&
                    <CustomImage option={option} index={index} deletedFiles={deletedFiles}
                      setDeletedFiles={setDeletedFiles} key={index} editFlag={editFlag} filesInfo={MOAFilesInfo} />

                ))
              }
              </Grid>
                {editFlag && 
              <DropzoneArea
                acceptedFiles={[
                  "application/pdf"

                ]}
                name="memorandum_of_association"
                filesLimit={3}
                dropzoneText="Drop files here or click to upload."
                onChange={handleInputChangeDropzoneMOA}
                showPreviews={false}
                showPreviewsInDropzone={true}
                maxFileSize={20480000000}
                dropzoneParagraphClass={classes.dropzoneParagraphClass}
                disabled={editFlag ? false : true}
              />
}
            </Grid>
            <Divider />
            <Grid
              item
              xs={12}
              style={{
                marginTop: "15px",
                padding: "25px",
                border: "1px solid #ddd",
              }}
            >
              <Typography
                variant="subtitle1"
                component="div"
                gutterBottom
                style={{ fontWeight: "bold" }}
              >
                Articles of Association(AOA) Document
              </Typography>
              <Typography
                variant="caption"
                display="block"
                style={{ marginBottom: "10px" }}
                gutterBottom
              >
                Note* Upload scan copy of Articles of Association(AOA) document in pdf format.
              </Typography>
              <Grid
                item
                xs={12} container
                style={{
                  marginTop: "15px",
                  marginBottom: "15px",
                  padding: "25px",
                  border: "1px solid #ddd",
                }}
              > 
              {formValuesCompany.article_of_association != undefined && formValuesCompany.article_of_association.length!= 0 &&
                formValuesCompany.article_of_association.map((option, index) => (

                  (deletedFiles.length && deletedFiles.includes(option)) ?
                    false
                    : AOAFilesInfo.length &&
                    <CustomImage option={option} index={index} deletedFiles={deletedFiles}
                      setDeletedFiles={setDeletedFiles} key={index} editFlag={editFlag} filesInfo={AOAFilesInfo} />

                ))
              }
              </Grid>
                {editFlag && 
              <DropzoneArea
                acceptedFiles={[
                  "application/pdf"

                ]}
                name="article_of_association"
                filesLimit={3}
                dropzoneText="Drop files here or click to upload."
                onChange={handleInputChangeDropzoneAOA}
                showPreviews={false}
                showPreviewsInDropzone={true}
                maxFileSize={20480000000}
                dropzoneParagraphClass={classes.dropzoneParagraphClass}
                disabled={editFlag ? false : true}
              />
              }
            </Grid>
              {!props.readableStatus && 
                    <Grid item xs={12} >
                  <Button variant="contained" className={classes.customButton}  type="submit" style={{ marginTop: "15px", marginBottom: "15px" }} disabled={editFlag ? false : true}>
                      Submit
                    </Button>
                    </Grid>
              }
                  </Grid>
                </form>
      </>  
        }
      </>     
      )


};
export default withStyles(styles)(CompanyComponent);